var Accordion = /** @class */ (function () {
    function Accordion() {
        this.selectors = {
            accordion: '[data-accordion]',
            trigger: '[data-accordion-trigger]',
            content: '[data-accordion-content]',
            icon: '[data-accordion-icon]'
        };
        this.nodeList = {
            accordions: document.querySelectorAll(this.selectors.accordion)
        };
    }
    Accordion.prototype.init = function () {
        var _this = this;
        this.nodeList.accordions.forEach(function (accordion) {
            _this.addEventListeners(accordion);
        });
    };
    Accordion.prototype.addEventListeners = function (accordion) {
        var trigger = accordion.querySelector(this.selectors.trigger);
        trigger.addEventListener('click', this.handleTriggerClick.bind(this, accordion));
    };
    Accordion.prototype.handleTriggerClick = function (accordion) {
        var content = accordion.querySelector(this.selectors.content);
        var accordionElm = accordion;
        var accordionElmTitle = accordion.querySelector('h2');
        var plusIcon = accordion.querySelector(this.selectors.icon).querySelector('.minus_open');
        var minusIcon = accordion.querySelector(this.selectors.icon).querySelector('.plus_closed');
        // only if on product page for specific accordion - product page has the 2 elements above so I check for those before
        if (plusIcon != null && minusIcon != null) {
            plusIcon.classList.toggle('hidden');
            minusIcon.classList.toggle('block');
            minusIcon.classList.toggle('hidden');
            accordionElm.classList.toggle('border-b');
            accordionElmTitle.classList.toggle('border-b');
        }
        content.classList.toggle('hidden');
    };
    return Accordion;
}());
export { Accordion };
;
